import moment from 'moment';
import { routeConfigCommon, routeConfigAdmin,routeConfigVendor, routeConfigSubVendor, routeConfigDynamic} from 'routes/RouteConfig';
import { emailReg, mobileNumberReg,percentageRegex,vehicleRegex } from './Regex';
import ErrorMessage from 'components/error/ErrorMessage';
  
  export const getCurrentUser = () => {
    let user = null;
    try {
      user =
        localStorage.getItem("token") != null
          ? localStorage.getItem("token")
          : null;
    } catch (error) {
      user = null;
    }
    return user;
  };
  
  export const setCurrentUser = (user) => {
    try {
      if (user) {
        return user.data
      } else {
        return user
      }
    } catch (error) {
      return error
    }
  };

  export const setCustomerComplaint = (complaint) => {
    try {
      if (complaint) {
        return complaint.data;
      } else {
        return complaint;
      }
    } catch (error) {
      return error;
    }
  };

  export const handleValidationForm = (data) => {
    let formIsValid = true;
    let errorVal = {};
    const emailRegex = emailReg;
    const mobileRegex = mobileNumberReg;
    let keys = Object.keys(data);
  
    keys.forEach((type, idx) => {
      // Prevent empty spaces at the beginning of the input
      if (typeof data[type] === 'string' && data[type].startsWith(' ')) {
        formIsValid = false;
        errorVal[type] = (
          <ErrorMessage errorMessage={'Cannot start with an empty space'} />
        );
        return;
      }
  
      switch (type) {
        case "mobileOrEmail":
          //check input validation
          if (type === "mobileOrEmail" && data[type]?.length !== 10) {
            if (emailRegex.test(data[type])) {
              errorVal[type] = "";
            } else {
              formIsValid = false;
              errorVal[type] = (
                <ErrorMessage errorMessage={'Email or Mobile is incorrect'} />
              );
            }
          }else if(data[type]?.length === 10){
            if(Number(data[type])){
              errorVal[type] = "";
            }else{
              formIsValid = false;
              errorVal[type] = (
                <ErrorMessage errorMessage={'Email or Mobile is incorrect'} />
              );
            }
          } else {
            errorVal[type] = "";
          }
          break;
        case "vendorName":
          //check input validation
          if (type === "vendorName" && data[type]?.length < 1) {
            formIsValid = false;
            errorVal[type] = (
              <ErrorMessage errorMessage={'This field is required'} />
            );
          } else {
            errorVal[type] = "";
          }
          break;
        case "number":
          //check input validation
          if(data[type]?.length !== 10){
            formIsValid = false;
            errorVal[type] = (
              <ErrorMessage errorMessage={'Mobile number is incorrect'} />
            );
          } 
          else if (!mobileRegex.test(data[type])) {
            // Check if it matches the mobile number regex
            formIsValid = false;
            errorVal[type] = (
              <ErrorMessage errorMessage={'Mobile number is incorrect'} />
            );
          } else {
            errorVal[type] = "";
          }
          break;
        case "mobile":
          //check input validation
          if(data[type]?.length !== 10){
            formIsValid = false;
            errorVal[type] = (
              <ErrorMessage errorMessage={'Mobile number is incorrect'} />
            );
          } else if (data[type]?.length === 10) {
            if (Number(data[type])) {
            } else {
              formIsValid = false;
              errorVal[type] = (
                <ErrorMessage errorMessage={'Mobile number is incorrect'} />
              );
            }
          } else {
            errorVal[type] = "";
          }
        break;
        case "email":
          //check input validation
          if (type === "email" && emailRegex.test(data[type])) {
            errorVal[type] = "";
          } else {
            if(data[type]?.length > 0){
              formIsValid = false;
              errorVal[type] = (
                <ErrorMessage errorMessage={'Enter a valid email address'} />
              );
            }
          }
          break;
          case "perventageValue":
            //check input validation
            if (type === "perventageValue" && percentageRegex.test(data[type])) {
              errorVal[type] = "";
            } else {
              if(data[type]?.length > 0){
                formIsValid = false;
                errorVal[type] = (
                  <ErrorMessage errorMessage={'Percentage cannot be greater than 100'} />
                );
              }
            }
            break;
            case "regNumber": {
              if ( vehicleRegex.test(data[type])) {
                errorVal[type] = "";
              } else {
                formIsValid = false;
                errorVal[type] = (
                  <ErrorMessage errorMessage={"Enter a valid Vehicle Number"} />
                );
              }
          }
          break;
        default:
          formIsValid = true;
          errorVal = {};
      }
  
      // Check if required is false and length is 0
      if (!data[type] && data[type]?.length === 0) {
        errorVal[type] = "";
      }
    });
  
    return { formIsValid, errorVal };
  };
  
  export const appRoot = "/app";

  export const isAuthUsers = (path) => {
    let isAuth = false;
  
    let routeConfig = dynamicRoutingByModule(routeConfigDynamic);
  
    routeConfig?.forEach((route) => {
      if (route.path === path) {
        isAuth = route.isAuth;
      }
      return isAuth;
    });
  
    return isAuth;
  };
  export const truncateComment = (comment, wordLimit) => {
    if (comment?.length > wordLimit) {
      return comment.slice(0, wordLimit) + "...";
    } else {
      return comment;
    }

  };

  export const dateFormate = (date, dFormate) => {
    if(dFormate ==='toIsoString'){
      const formedDate = moment(date).toISOString();

      if(formedDate == 'Invalid date') {
        return date || '';
      }

      return formedDate
    } else if(date !== null && date !== undefined && date !== "" && date !== "Invalid date"){
        const formedDate = moment(date).local().format(dFormate)
        if(formedDate == 'Invalid date') {
          return date || '';
        }

        return formedDate
      } else{
        return ""
      }
  };

  export const getTimeFormat = (data) => {
    if (data) {
      return moment(data).format("HH:mm");
    }
  };

  //Dynamic routing filtering
export  const dynamicRoutingByModule = (arr1) => {

  const dynamicRouting = localStorage.getItem("rolesPermissions")?.length > 0 && JSON.parse(localStorage.getItem("rolesPermissions"));
  

  let res = [];
  res = arr1?.filter(el => {
     return dynamicRouting?.length && dynamicRouting?.find(element => {
        return element.toLowerCase() === el?.moduleKey?.toLowerCase();
     });
  });
 
  return res;
}

export const handlePermissions = (permissionArray, module, accessKey) => {
  const findPermissions = (modules) => {
    if (!modules || !Array.isArray(modules)) return false;

    for (let i = 0; i < modules.length; i++) {
      const moduleItem = modules[i];
      const permissionsAccess = moduleItem.Permissions?.map(perm => perm.permissionName);
      
      if (permissionsAccess?.includes(accessKey.customAccess)) return true;
      if (permissionsAccess?.includes(accessKey.defaultAllAccess)) return true;

      if (moduleItem.subModule && moduleItem.subModule.length > 0) {
        const subModulePermission = findPermissions(moduleItem.subModule);
        if (subModulePermission) return true;
      }
    }

    return false;
  };

  const moduleItem = permissionArray?.find(arr => arr.moduleKey === module);
  if (!moduleItem) return false;

  const permissionsAccess = moduleItem.Permissions?.map(perm => perm.permissionName);

  if (permissionsAccess?.includes(accessKey.customAccess)) return true;
  if (permissionsAccess?.includes(accessKey.defaultAllAccess)) return true;

  return findPermissions(moduleItem.subModule);
};

// Function to fix the digit after decimal
export const formatNumber = (value) => {
  if (typeof value === "number") {
    return value.toFixed(2);
  }
  return value;
};

  export const isNumeric = (value)  => {
    return (
      /^[0-9.]*$/.test(value) && !value.includes("e") && !value.includes("-")
    );
  }

  export const getReservationDetailsObject = (reservationData) => {
    if (reservationData?.AirportTrip) {
      return reservationData?.AirportTrip;
    } else if (reservationData?.B2bRentalTrip) {
      return reservationData?.B2bRentalTrip;
    } else if (reservationData?.OutStationTrip) {
      return reservationData?.OutStationTrip;
    } else if (reservationData?.OutStationTripOneWay) {
      return reservationData?.OutStationTripOneWay;
    } else {
      return {};
    }
  };

export const validateFieldOnChange = (fieldConfig, value) => {
  const { required, validation, label, name } = fieldConfig;

  if (required && (!value || value.trim().length === 0)) {
    return {
      isValid: false,
      error: `${label || name} is required`
    };
  }

  if (validation?.pattern?.value instanceof RegExp) {
    if (!validation.pattern.value.test(value)) {
      return {
        isValid: false,
        error: `${validation.pattern.message || "Invalid format"}`,
      };
    }
  }

  return { isValid: true, error: "" };
};

export const dateFormateForFareScreen = (date, dFormate) => {
  if(dFormate === 'calendar'){
    return moment(date).calendar()
  }else{
    return moment(date).format(dFormate)
  }
  
};